export default function PageHeader({ eyebrow, title, description, testId }) {
    return (
        <section
            data-testid={testId || "page-header"}
            className="bg-white border-b border-slate-200"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-7">
                        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
                        <h1 className="font-display mt-4 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tighter text-slate-900 leading-[1.05]">
                            {title}
                        </h1>
                    </div>
                    {description && (
                        <div className="lg:col-span-5 lg:pt-3">
                            <p className="text-base md:text-lg text-slate-600 leading-relaxed">
                                {description}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
